import { useQuery } from '@tanstack/react-query';
import { createHistoryReader, createRpcClient } from '@gonka-wallet/chain';
import { useSettingsStore } from '../stores/settingsStore.js';
import { resolveSeeds } from '../lib/resolveSeeds.js';

export function useHistory(address: string | null) {
  const source = useSettingsStore((s) => s.chainNodeSource);
  const customUrl = useSettingsStore((s) => s.customNodeUrl);

  return useQuery({
    queryKey: ['history', address, source, customUrl],
    queryFn: async () => {
      if (!address) return null;
      const seeds = resolveSeeds(source, customUrl);
      const client = createRpcClient(seeds);
      const reader = createHistoryReader(client, null);
      return reader.get(address);
    },
    enabled: !!address,
    staleTime: 30_000,
  });
}
